'use client';
import { FC, useCallback } from 'react';
import Image from 'next/image';
import {
  CatCard,
  CatHeading,
  CatIconSuccess
} from 'components/blocks-components';
import SerialNumber from './serial-number';
import { equipmentHeader, formatHeader } from './utils';
import { Equipment } from 'services/equipment/types';
import cx from 'classnames';
import Styles from './my-equipment-card.module.scss';
import { v4 as uuidv4 } from 'uuid';

export interface MyEquipmentCardProps {
  equipment: Equipment;
  isSelected: boolean;
  handleEditOpen: (equipment: Equipment) => void;
  partModificationFeatureFlag?: boolean;
}

const MyEquipmentCard: FC<MyEquipmentCardProps> = ({
  equipment,
  handleEditOpen,
  isSelected = false,
  partModificationFeatureFlag = false
}) => {
  const {
    id = '',
    imageURL = '',
    serialNumber = '',
    productFamily = '',
    name = ''
  } = equipment || {};

  const handleOpen = useCallback(() => {
    handleEditOpen?.(equipment);
  }, [equipment, handleEditOpen]);

  return (
    <div
      className={cx('h-100', Styles['c-equipment-card'], {
        ['border-black']: isSelected
      })}
    >
      <CatCard removePadding variant="bare">
        <div
          className={cx('w-100 d-flex align-items-center px-2 pt-2', {
            ['invisible']: !isSelected
          })}
        >
          <CatIconSuccess slot="after" size="lg" />
        </div>
        <div className="d-flex justify-content-center align-items-center pb-2">
          <Image
            src={imageURL}
            alt={productFamily}
            className={Styles['c-equipment-card__image']}
            loading="lazy"
            width={160}
            height={100}
            unoptimized
          />
        </div>
        <div className="mx-3">
          <CatHeading variant="display-sm">
            {partModificationFeatureFlag ? (
              formatHeader(name)
            ) : (
              <div>
                {equipmentHeader(equipment).map((item) => (
                  <div key={uuidv4()} className={`text-truncate`}>
                    {item}
                  </div>
                ))}
              </div>
            )}
          </CatHeading>
        </div>
        <SerialNumber
          serialNumber={serialNumber}
          equipmentId={id}
          handleOpen={handleOpen}
        />
      </CatCard>
    </div>
  );
};

export default MyEquipmentCard;
